import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCartRejectedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 198,
	height: 149,
	viewBox: "0 0 198 149",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5243_35564)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M112.537 24.2199L158.59 84.1924C162.944 89.862 161.875 97.9997 156.206 102.353L140.808 114.177L78.9782 33.6596L94.3758 21.8357C100.045 17.482 108.183 18.5503 112.537 24.2199Z",
				fill: "#E88E43"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.265 116.129L76.4355 35.6113L73.2247 38.0769L135.055 118.595L138.265 116.129Z",
				fill: "#B6B7B6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.645 45.9897C179.341 52.3662 162.576 52.4289 145.195 60.4995L131.594 42.7874C143.771 28.3617 148.78 12.2795 156.944 6.01014C167.985 -2.46765 183.807 -0.390614 192.284 10.6493C200.762 21.6895 198.685 37.5118 187.645 45.9897Z",
				fill: "#E88E43"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.5296 115.302L35.7234 131.595C35.3048 131.719 34.8744 131.78 34.4453 131.78C33.7739 131.78 33.1052 131.63 32.4882 131.332C31.474 130.844 30.6843 130 30.2643 128.956L30.2054 128.789L19.8486 95.07L4.02315 99.6901L1.49805 91.0412L21.3991 85.2309C22.4727 84.9127 23.6234 85.0055 24.6352 85.4931C25.6495 85.9819 26.4393 86.8259 26.8591 87.8698L26.918 88.0364L37.2792 121.754L84.6759 107.916L80.1626 92.4574L88.8199 89.93L94.5958 109.714C94.9332 110.869 94.7997 112.087 94.2198 113.143C93.6406 114.198 92.6852 114.965 91.5296 115.302ZM95.862 126.35C94.6494 122.196 90.2993 119.812 86.1458 121.025C81.9924 122.238 79.6083 126.588 80.8209 130.741C82.0336 134.895 86.3838 137.279 90.5372 136.067C94.6907 134.854 97.0747 130.503 95.862 126.35ZM44.0308 133.321C39.8773 134.533 37.4933 138.883 38.7059 143.037C39.9185 147.19 44.2687 149.575 48.4222 148.362C52.5757 147.149 54.9595 142.799 53.7469 138.646C52.5343 134.492 48.1843 132.108 44.0308 133.321ZM74.2526 98.1928L59.6683 90.3941L67.467 75.8098L60.7553 72.2207L52.9565 86.8051L38.3721 79.0063L34.7832 85.718L49.3675 93.5168L41.5688 108.101L48.2805 111.69L56.0793 97.1058L70.6636 104.905L74.2526 98.1928Z",
				fill: "#F45D5D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5243_35564",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 197,
			height: 149,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgCartRejectedIcon;
